
//const SERVICE_UUID = '0000ffe0-0000-1000-8000-00805f9b34fb';
//const CHARACTERISTIC_TX = '0000ffe1-0000-1000-8000-00805f9b34fb';
//const CHARACTERISTIC_RX = '0000ffe2-0000-1000-8000-00805f9b34fb';

const SERVICE_UUIDS = {
    Nybble: '0000ffe0-0000-1000-8000-00805f9b34fb',
    Bittle: '6e400001-b5a3-f393-e0a9-e50e24dcca9e',
};

const CHARACTERISTICS = {
    Nybble: {
        TX: '0000ffe1-0000-1000-8000-00805f9b34fb',
        RX: '0000ffe2-0000-1000-8000-00805f9b34fb',
    },
    Bittle: {
        TX: '6e400003-b5a3-f393-e0a9-e50e24dcca9e', // 3 ending has notify
        RX: '6e400002-b5a3-f393-e0a9-e50e24dcca9e', // 2 ending is for writing to
    }
}



const VER_QUERY = '?';
const SOFTWARE_ID = 'Ver_112624'
const MODEL_ID = 'LocoScout'


const SERIAL_DELAY = 100; // ms
const BLE_CONNECT_TIMEOUT = 2000; // ms
const MAX_CHUNK_SIZE = 15; // # of bytes

const DATA_CHECK_RATE = 10; // ms

const MAX_ATTEMPTS = 4;
export const LS_SENSOR_REJECT_VALUE = -10000;

export const BLE_NOTIFICATION = 'characteristicvaluechanged';

export const CALIB_MIN = -20; // deg
export const CALIB_MAX = 20; // deg

export const STATUS_SUCCESS = 1;
export const STATUS_FAILURE = 0;
export const VERSION_FAILURE = 2;
export const STATUS_LOST = -1;

export const LS_SITE_LINK = "https://codemyrobots.com/product/locoscout/";


class BluetoothDevice {

    constructor() {
        this.isConnected = false;
        this.initialMessagesFlag = true;
        this.resolveInitialMessagesPromise = null;
        this.initialMessagesPromise = null;
        this.timeoutId = null;
        this.intervalId = null;
        this.buffer = '';
        //
        this.data = '';
        this.appendData = false;
        this.disableCharacter = null;
        //
        this.boundHandleNotifications = this.handleNotifications.bind(this);

        this.version = null;
        
        this.bufferSize = 100;

        this.optionNames = [
            'Accelerometer', 'Attitude', 'Battery', 'Light', 'IR Distance', 'Touch', 'PIR'
        ];

        this.B = "Bittle";
        this.BV0 = 'BV0';
        this.BV1 = 'BV1';

        this.options = {
            'Accelerometer': {refer: 'READ_ACC', count: 3, range: ['min', 'min', 'min'], offset: 1.2},
            'Attitude': {refer: 'READ_ATT', count: 3, range: ['min', 'min', 'min'], offset: 2},
            'Battery': {refer: 'READ_BATTERY', count: 1, range: ['fixed'], fixed: [6.5, 8.5]},
            'Light': {refer: 'READ_LIGHT', count: 2, range: ['min', 'min'], offset: 10,},
            'IR Distance': {refer: 'READ_IR', count: 1, range: ['min'], offset: 5,},
            'Touch': {refer: 'READ_TOUCH', count: 2, range: ['fixed'], fixed: [-0.1, 1.1] },
            'PIR': {refer: 'READ_PIR', count: 1, range: ['fixed'], fixed: [-0.1, 1.1]},
        };
        
        this.self = {
            READ_ACC: {
                value: ['f'],
                names: ['Acc X', 'Acc Y', 'Acc Z'],
                ylabels: ["X (g)", "Y (g)", "Z (g)"],
                arrays: ['accArrayX', 'accArrayY', 'accArrayZ'],
            },
            READ_ATT: {
                value: ['f'],
                names: ['Roll', 'Pitch', 'Yaw'],
                ylabels: ["Roll (deg)", "Pitch (deg)", "Yaw (deg)"],
                arrays: ['rArray', 'pArray', 'yArray'],
            },
            READ_BATTERY: {
                value: ['h'],
                names: ['Battery'],
                ylabels: ["Battery (V)"],
                arrays: ['batArray'],
            },
            READ_LIGHT: {
                value: ["Ra", "Ra"],
                hex: [0x10, 0x11],
                names: ['Light 1', 'Light 2'],
                ylabels: ["Light (#)", "Light (#)"],
                arrays: ['lightArray1', 'lightArray2'],
            },
            READ_IR: {
                value: ["Ra", "Ra"],
                hex: [0x11, 0x10],
                avg: true,
                names: ['IR'],
                ylabels: ["IR (cm)"],
                arrays: ['irArray1'],
            },
            READ_TOUCH: {
                value: ["Rd", "Rd"],
                hex: [0x06, 0x07],
                names: ['Touch', 'Touch'],
                ylabels: ["Touch (OFF/ON)", "Touch (OFF/ON)"],
                arrays: ['touchArray1', 'touchArray2'],
            },
            READ_PIR: {
                value: ["Rd"],
                hex: [0x08],
                names: ['PIR'],
                ylabels: ["PIR (OFF/ON)"],
                arrays: ['pirArray'],
            },
            accArrayX: [],
            accArrayY: [],
            accArrayZ: [],
            rArray: [],
            pArray: [],
            yArray: [],
            batArray: [],
            lightArray1: [],
            lightArray2: [],
            irArray1: [],
            irArray2: [],
            touchArray1: [],
            touchArray2: [],
            pirArray: [],
        };
    }

    resetArrays = () => {
        this.self.accArrayX = []
        this.self.accArrayY = []
        this.self.accArrayZ = []
        this.self.rArray = []
        this.self.pArray = []
        this.self.yArray = []
        this.self.batArray = []
        this.self.lightArray1 = []
        this.self.lightArray2 = []
        this.self.irArray1 = []
        this.self.irArray2 = []
        this.self.touchArray1 = []
        this.self.touchArray2 = []
        this.self.pirArray = []
    }

    check_version = async () => {

        //for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
            try {        

                // enable appending
                this.enableAppending(VER_QUERY);

                await this.setData(VER_QUERY);

                // wait for the data to be complete
                await this.waitForDataComplete();
            } catch (error) {
                //console.log(error);
                //if (attempt === (MAX_ATTEMPTS - 1)) {
                    console.log("Failed to get version data")
                    return STATUS_FAILURE;
                //}
            }
        //}
        
        // process data for corresponding array
        let resp = null;
        try {
            resp = this.data.split('\n');
        } catch (error) {
            console.log("Failed to get version data")
            return STATUS_FAILURE;
        }
        // find first element in resp array that has a "=" in it
        //let data_value = resp.find(item => item.includes("="));

        //let model_str = data_value.slice(1);
        //let software_str = resp[1].slice(1);
        //console.log("ver resp", resp)
        //if (model_str === MODEL_ID) {
        //if (resp.some(item => item.includes(MODEL_ID))) {
        
        const validItem = resp.find(item => item.includes(MODEL_ID)); // Find the first valid item

        // boolean checks
        const hasB0 = Array.isArray(resp) && resp.some(item => item.includes('B0'));
        const hasB1 = Array.isArray(resp) && resp.some(item => item.includes('B1'));

        if (validItem) {
            if (hasB0) {
                this.version += 'BV0';
                window.bleComms.version += 'BV0';
                this.optionNames = [
                    'Accelerometer', 'Attitude'
                ];
            } else if (hasB1) {
                this.version += 'BV1';
                window.bleComms.version += 'BV1';
                this.optionNames = [
                    'Accelerometer', 'Attitude', 'Battery', 'Light', 'IR Distance', 'Touch', 'PIR'
                ];
            } else {
                this.optionNames = [
                    'Accelerometer', 'Attitude', 'Battery', 'Light', 'IR Distance', 'Touch', 'PIR'
                ];
            }
            return STATUS_SUCCESS;
        } else {
            return VERSION_FAILURE;
        }
    }

    send_command = async (ref_obj) => {

        // make copy of value array
        let data_msg = [...ref_obj.value];

        // make copy of array names array
        let names = [...ref_obj.arrays]; 

        // if doesn't have hex property
        if (!ref_obj.hasOwnProperty('hex')) {

            for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
                try {        
                    // enable appending
                    this.enableAppending(data_msg[0]);

                    // send command
                    await this.setData(data_msg[0]);
            
                    // wait for the data to be complete
                    await this.waitForDataComplete();
                    break; // If successful, exit the loop
                } catch (error) {
                    if (attempt === (MAX_ATTEMPTS - 1)) {
                        throw error; // If second attempt fails, propagate the error
                    }
                }
            }

            let data_value = ""
            if (window.bleComms.version.includes(this.NYB)) {
                // process data for corresponding array
                data_value = this.data.split('\n')[0];
                // remove leading "="
                data_value = data_value.slice(1);
            }
            
            // acc or att
            if (ref_obj.names[0].includes("Roll") || ref_obj.names[0].includes("Acc")) {

                if (window.bleComms.version.includes(this.B)) {
                    this.data = this.data.slice(0, -1); // remove last character
                    data_value = this.data.split('\n')[0];
                    //const withoutPrefix = this.data.replace(/^(MCU:|ICM:)\s*/, "");
                    /*
                    const parts = withoutPrefix.split(/\s+/);
                    const numbers = parts.map(Number);
                    if (ref_obj.names[0].includes("Roll")) {
                        data_value = numbers.slice(-3);
                    } else if (ref_obj.names[0].includes("Acc")) {
                        data_value = numbers.slice(0, 3).map(num => (num / 10).toFixed(2));
                    }
                    */
                }
                if (ref_obj.names[0].includes("Roll")) {
                    // split data by commas and take latter 3 values, each cast to float 
                    data_value = data_value.split(',').slice(0, 3).map(x => parseFloat(x).toFixed(2));
                    // reverse the order
                    data_value = data_value.reverse();

                } else if (ref_obj.names[0].includes("Acc")) {
                    // split data by commas and take first 3 values, each cast to float
                    data_value = data_value.split(',').slice(-3).map(x => parseFloat(x).toFixed(2));
                }
                for (let i = 0; i < names.length; i++) {
                    this.self[names[i]].push(data_value[i]);
                    // Handle buffer size
                    if (this.self[names[i]].length > this.bufferSize) {
                        this.self[names[i]].shift();
                    }
                }
            } else { // battery
                // cast data_value to float
                data_value = parseFloat(data_value);

                this.self[names[0]].push(data_value);
                // Handle buffer size
                if (this.self[names[0]].length > this.bufferSize) {
                    this.self[names[0]].shift();
                }
            }

        // if has hex property
        } else if (ref_obj.hasOwnProperty('hex')) {

            let hex_msg = [...ref_obj.hex];
            // process data as get it, for arrays
            // iterate through data_msg array

            if (ref_obj.hasOwnProperty('avg')) {

                //_IR: {
                //value: ["Ra", "Ra"],
                let data_avg = 0;
                let div_value = data_msg.length;
                for (let i = 0; i < data_msg.length; i++) {

                    for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
                        try {        
                            // enable appending
                            this.enableAppending(data_msg[i][0]);

                            // send each command
                            //await this.setData(data_msg[i]);
                            await this.setWithBin(data_msg[i], hex_msg[i]);
                    
                            // wait for the data to be complete
                            await this.waitForDataComplete();
                            break; // If successful, exit the loop
                        } catch (error) {
                            if (attempt === (MAX_ATTEMPTS - 1)) {
                                throw error; // If second attempt fails, propagate the error
                            }
                        }
                    }

                    // process data for corresponding array
                    let data_value = this.data.split('\n')[0];
                    
                    // remove "=" and convert to integer
                    data_value = parseInt(data_value.slice(1));
                    //if (isNaN(data_value)) { data_value = 0; }
                    // if data_value is nan, skip
                    if (isNaN(data_value)) { 
                        div_value--;
                        continue; 
                    }
                    data_avg += data_value;
                }
                try {
                    data_avg = data_avg / data_msg.length;

                    const x = data_avg;
                    data_avg = 12.1 + 3.34 * x + -0.0118 * Math.pow(x, 2) + 1.33e-5 * Math.pow(x, 3);

                    data_avg = data_avg < 0 ? 0 : data_avg;
                    // convert from mm to cm
                    data_avg = data_avg / 10;
                    // convert to integer
                    data_avg = parseInt(data_avg);

                } catch {/* both values were bad */}
                
                this.self[names[0]].push(data_avg);
                // Handle buffer size
                if (this.self[names[0]].length > this.bufferSize) {
                    this.self[names[0]].shift();
                }

            } else {

                for (let i = 0; i < data_msg.length; i++) {

                    for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
                        try {        
                            // enable appending
                            this.enableAppending(data_msg[i][0]);

                            // send each command
                            //await this.setData(data_msg[i]);
                            await this.setWithBin(data_msg[i], hex_msg[i]);
                    
                            // wait for the data to be complete
                            await this.waitForDataComplete();
                            break; // If successful, exit the loop
                        } catch (error) {
                            if (attempt === (MAX_ATTEMPTS - 1)) {
                                throw error; // If second attempt fails, propagate the error
                            }
                        }
                    }

                    // process data for corresponding array
                    let data_value = this.data.split('\n')[0];
                    
                    // remove "=" and convert to integer
                    data_value = parseInt(data_value.slice(1));
                    //if (isNaN(data_value)) { data_value = 0; }
                    // if data_value is nan, skip
                    if (isNaN(data_value)) { continue; }

                    // Special processing for IR/Light
                    if (ref_obj.names[i].startsWith("IR")) {
                        /*
                        const x = data_value;
                        const result = -56.5 +
                            5.13 * x +
                            -0.0416 * Math.pow(x, 2) +
                            1.56E-04 * Math.pow(x, 3) +
                            -2.64E-07 * Math.pow(x, 4) +
                            1.64E-10 * Math.pow(x, 5) +
                            7.71E-15 * Math.pow(x, 6);
                        data_value = result < 0 ? 0 : result;
                        // convert from mm to cm
                        data_value = data_value / 10;
                        */
                    //console.log(ref_obj.names[i], hex_msg[i], data_value)
                    } else if (ref_obj.names[i].startsWith("Light")) {
                        const x = data_value;
                        const result = -2.38 +
                            0.0492 * x +
                            1.71E-03 * Math.pow(x, 2) +
                            -4.47E-06 * Math.pow(x, 3) +
                            5.65E-09 * Math.pow(x, 4);
                        data_value = result < 0 ? 0 : result;
                    }

                    // other extra processing if IR or Light
                    //if (ref_obj.names[i].startsWith("IR") || ref_obj.names[i].startsWith("Light")) {
                    if (ref_obj.names[i].startsWith("Light")) {
                        // Filtering logic
                        const oldData = [...this.self[names[i]]];
                        const newData = data_value;

                        let windowSize = 2; // Define the window size for the moving average
                        // Example filtering logic: simple moving average
                        if (ref_obj.names[i].startsWith("IR")) {
                            windowSize = 2;
                        } else if (ref_obj.names[i].startsWith("Light")) {
                            windowSize = 2;
                        }
                        
                        if (oldData.length >= windowSize) {
                            const sum = oldData.slice(-windowSize).reduce((acc, val) => acc + val, 0);
                            const average = sum / windowSize;
                            data_value = (average + newData) / 2; // Update data_value with the filtered value
                        } else if (((oldData.length > 1)) && (oldData.length < windowSize)) {
                            // average as many data points as available
                            const sum = oldData.reduce((acc, val) => acc + val, 0);
                            const average = sum / oldData.length;
                            data_value = (average + newData) / 2; // Update data_value with the filtered value
                        }
                    }
                    if (ref_obj.names[i].startsWith("IR")){
                        // convert to integer
                        //data_value = parseInt(data_value);
                    } else if (ref_obj.names[i].startsWith("Light")) {
                        // round to nearest 0.1
                        data_value = Math.round(data_value * 10) / 10;
                    }

                    this.self[names[i]].push(data_value);
                    // Handle buffer size
                    if (this.self[names[i]].length > this.bufferSize) {
                        this.self[names[i]].shift();
                    }

                }
            }
            
        }
    }
    
    get_data_array = (type) => {
        return type.map(name => this.self[name]);
    };

    set_buffer_size = (buffer_size) => {
        this.bufferSize = buffer_size
    }

    get_buffer_size = () => {
        return this.bufferSize
    }

    reset() {
        //window.bleComms.device = null;
        window.bleComms.server = null;
        window.bleComms.rxCharacteristic = null;
        window.bleComms.txCharacteristic = null;
        this.isConnected = false;
        this.initialMessagesFlag = true;
        this.resolveInitialMessagesPromise = null;
        this.initialMessagesPromise = null;
        this.timeoutId = null;
        this.intervalId = null;
        this.buffer = '';
        //
        this.data = '';
        this.appendData = false;
        this.disableCharacter = null;
        // robot version
        this.version = null;
    }

    async connectDeviceOnly() {
        try {
            this.reset();

            // Request Bluetooth Device (must be called within a user gesture)
            window.bleComms.device = await navigator.bluetooth.requestDevice({ 
                optionalServices: Object.values(SERVICE_UUIDS),
                filters: [
                    { namePrefix: 'Petoi' },
                    { namePrefix: 'Bittle'},
                ]
            });
            console.log('Device selected:', window.bleComms.device.name);
            if (window.bleComms.device.name.includes('Bittle')) {
                this.version = 'Bittle';
                window.bleComms.version = 'Bittle';
                this.self.READ_BATTERY.value = ['P']
                this.self.READ_ACC.value = ['E']
                this.self.READ_ATT.value = ['E']
            } else {
                this.version = 'Nybble';
                window.bleComms.version = 'Nybble';
                this.self.READ_BATTERY.value = ['h']
                this.self.READ_ACC.value = ['f']
                this.self.READ_ATT.value = ['f']
            }

            // Return the status to the caller
            return STATUS_SUCCESS;
        } catch (error) {
            console.error('Failed to select device:', error);

            // Return failure status if device selection fails
            return STATUS_FAILURE;
        }
    }

    // BLE Connect Function
    async connect() {
        try {
            this.reset();

            // Request Bluetooth Device
            window.bleComms.device = await navigator.bluetooth.requestDevice({ 
                optionalServices: Object.values(SERVICE_UUIDS),
                filters: [
                    { namePrefix: 'PetoiBLE' },
                    { namePrefix: 'Bittle'},
                ]
            });

            // Proceed to attempt connection
            const status = await this.ble_connect_internal();
            if (status === STATUS_SUCCESS) {
                console.log('BLE connection successful.');
                // Wait 2 seconds before sending another message
                await new Promise(resolve => setTimeout(resolve, 2000));
            } else if (status === VERSION_FAILURE) { 
                console.error("Incompatible Robot Firmware.")
            } else {
                console.error('BLE connection failed.');
            }

            // Return the status to the caller
            return status;
        } catch (error) {
            console.error('Failed to select device:', error);

            // Return failure status if device selection fails
            return STATUS_FAILURE;
        }
    }

    async ble_connect_internal() {
        const MAX_CONNECTION_RETRIES = 4;
        let connectionRetryCount = 0;

        // Ensure a device has been selected
        if (!window.bleComms.device) {
            console.error('No device selected. Please select a device first.');
            return STATUS_FAILURE;
        }
        
        if (window.bleComms.device.name.includes('Bittle')) {
            this.version = 'Bittle';
            window.bleComms.version = 'Bittle';
            this.self.READ_BATTERY.value = ['P']
            this.self.READ_ACC.value = ['E']
            this.self.READ_ATT.value = ['E']
        } else {
            this.version = 'Nybble';
            window.bleComms.version = 'Nybble';
            this.self.READ_BATTERY.value = ['h']
            this.self.READ_ACC.value = ['f']
            this.self.READ_ATT.value = ['f']
        }
    
        while (connectionRetryCount < MAX_CONNECTION_RETRIES) {
            
            this.data = '';

            // Create a new promise for the initial messages
            this.initialMessagesPromise = new Promise(resolve => {
                this.resolveInitialMessagesPromise = resolve;
            });
            
            try {
                // Connect to GATT Server
                try {
                    window.bleComms.server = await window.bleComms.device.gatt.connect();
                } catch (gattError) {
                    console.error('Failed to connect to GATT Server:', gattError);
                    throw gattError;
                }
                
                // Wait 0.2 seconds before attempting to get Primary Service
                //await new Promise(resolve => setTimeout(resolve, 200));
    
                // Retry mechanism for getting the primary service
                const MAX_SERVICE_RETRIES = 4;
                let serviceRetryCount = 0;
                let service;
    
                const SERVICE_UUID = window.bleComms.device.name.includes('Bittle') ? SERVICE_UUIDS.Bittle : SERVICE_UUIDS.Nybble;

                while (serviceRetryCount < MAX_SERVICE_RETRIES) {
                    try {
                        service = await window.bleComms.server.getPrimaryService(SERVICE_UUID);
                        break; // Exit the loop if successful
                    } catch (serviceError) {
                        console.error('Failed to get Primary Service:', serviceError);
    
                        if (serviceError.name === 'NetworkError' && serviceError.message.includes('GATT Server is disconnected')) {
                            console.warn('GATT Server is disconnected. Attempting to reconnect...');
                            serviceRetryCount++;
    
                            // Attempt to reconnect
                            window.bleComms.server = await window.bleComms.device.gatt.connect();
                        } else if (serviceError.name === 'NotSupportedError') {
                            console.warn('NotSupportedError encountered. Retrying...');
                            serviceRetryCount++;
                        } else {
                            // For other errors, rethrow
                            throw serviceError;
                        }
    
                        if (serviceRetryCount >= MAX_SERVICE_RETRIES) {
                            throw new Error('Failed to get Primary Service after maximum retries.');
                        }
                    }
                }
    
                const CHARACTERISTIC_RX = window.bleComms.device.name.includes('Bittle') ? CHARACTERISTICS.Bittle.RX : CHARACTERISTICS.Nybble.RX;
                const CHARACTERISTIC_TX = window.bleComms.device.name.includes('Bittle') ? CHARACTERISTICS.Bittle.TX : CHARACTERISTICS.Nybble.TX;

                // Get RX Characteristic
                try {
                    window.bleComms.rxCharacteristic = await service.getCharacteristic(CHARACTERISTIC_RX);
                } catch (rxError) {
                    console.error('Failed to get RX Characteristic:', rxError);
                    throw rxError;
                }
    
                // Get TX Characteristic
                try {
                    window.bleComms.txCharacteristic = await service.getCharacteristic(CHARACTERISTIC_TX);
                } catch (txError) {
                    console.error('Failed to get TX Characteristic:', txError);
                    throw txError;
                }
    
                this.isConnected = true;
                
                // Remove previous event listeners
                window.bleComms.txCharacteristic.removeEventListener('characteristicvaluechanged', this.boundHandleNotifications);
    
                // Add the listener
                window.bleComms.txCharacteristic.addEventListener('characteristicvaluechanged', this.boundHandleNotifications);
    
                this.initialMessagesFlag = true;
    
                // Start notifications on TX Characteristic
                try {
                    await window.bleComms.txCharacteristic.startNotifications();
                } catch (notificationError) {
                    console.error('Failed to start notifications:', notificationError);
                    throw notificationError;
                }
    
                // Start the timer before awaiting initialMessagesPromise.
                this.timeoutId = setTimeout(this.resolveInitialMessagesPromise, BLE_CONNECT_TIMEOUT);
    
                // Wait for the initial messages to be received
                await this.initialMessagesPromise;
                this.initialMessagesFlag = false;
    
                // Wait 2 seconds before sending another message
                await new Promise(resolve => setTimeout(resolve, 2000));

                // check version
                try {
                    const status = await this.check_version();
                    return status;
                } catch (error) {
                    throw error;
                }
            } catch (error) {
                console.error(`Connection attempt ${connectionRetryCount + 1} failed:`, error);
    
                connectionRetryCount++;
    
                if (connectionRetryCount >= MAX_CONNECTION_RETRIES) {
                    console.error('Maximum connection retries reached.');
                    return STATUS_FAILURE;
                } else {
                    console.log(`Retrying connection (${connectionRetryCount}/${MAX_CONNECTION_RETRIES})...`);
                    // Wait 0.5 seconds before retrying
                    //await new Promise(resolve => setTimeout(resolve, 100));
                }
            }
        }
    }

/*
    async connect() {
        try {
            this.reset();

            // Create a new promise for the initial messages
            this.initialMessagesPromise = new Promise(resolve => {
                this.resolveInitialMessagesPromise = resolve;
            });

            window.bleComms.device = await navigator.bluetooth.requestDevice({ 
                //acceptAllDevices: true, 
                optionalServices: [SERVICE_UUID], // replace with your service UUID
                filters: [{
                    namePrefix: 'Petoi'
                }]
            });
            window.bleComms.server = await window.bleComms.device.gatt.connect();

            await new Promise(resolve => setTimeout(resolve, 200));

            const MAX_RETRIES = 3;
            let retryCount = 0;
            let service;
    
            while (retryCount < MAX_RETRIES) {
                try {
                    //console.log(`Attempting to get Primary Service (attempt ${retryCount + 1})...`);
                    service = await window.bleComms.server.getPrimaryService(SERVICE_UUID);
                    //console.log('Primary Service obtained:', service);
                    break; // Exit the loop if successful
                } catch (serviceError) {
                    console.error('Failed to get Primary Service:', serviceError);
    
                    if (serviceError.name === 'NetworkError' && serviceError.message.includes('GATT Server is disconnected')) {
                        console.warn('GATT Server is disconnected. Attempting to reconnect...');
                        retryCount++;
    
                        // Attempt to reconnect
                        //console.log('Reconnecting to GATT Server...');
                        window.bleComms.server = await window.bleComms.device.gatt.connect();
                        //console.log('Reconnected to GATT Server.');
                    } else {
                        // For other errors, rethrow
                        throw serviceError;
                    }
    
                    // If maximum retries reached, throw an error
                    if (retryCount >= MAX_RETRIES) {
                        throw new Error('Failed to get Primary Service after maximum retries.');
                    }
                }
            }
            
            window.bleComms.rxCharacteristic = await service.getCharacteristic(CHARACTERISTIC_RX);
            window.bleComms.txCharacteristic = await service.getCharacteristic(CHARACTERISTIC_TX);
            this.isConnected = true;

            window.bleComms.txCharacteristic.removeEventListener('characteristicvaluechanged', this.boundHandleNotifications);
            
            // Add event listener
            window.bleComms.txCharacteristic.addEventListener('characteristicvaluechanged', this.boundHandleNotifications);
            
            //this.initialMessagesFlag = true;
            await window.bleComms.txCharacteristic.startNotifications()
            
            // Start the timer before awaiting initialMessagesPromise.
            this.timeoutId = setTimeout(this.resolveInitialMessagesPromise, BLE_CONNECT_TIMEOUT);

            // Wait for the initial messages to be received
            await this.initialMessagesPromise;
            this.initialMessagesFlag = false;

            // wait 2 seconds before sending another message
            await new Promise(resolve => setTimeout(resolve, 2000));

            return STATUS_SUCCESS;
        } catch (error) {
            //console.log('connect error: ', error)
            return STATUS_FAILURE;
        }
    }
        */

    async disconnect() {
        await bleDeviceLS.setData('d');
        if (window.bleComms.device) {
            window.bleComms.device.gatt.disconnect();
            this.reset();
            // Wait for 2.5 seconds before resolving
            await new Promise(resolve => setTimeout(resolve, 2500));
        }
    }

    async setWithBin(cmd_data, hex_data) {
        if (window.bleComms.txCharacteristic) {

            let encoder = new TextEncoder('utf-8');
            let data = cmd_data + String.fromCharCode(hex_data); // Append character to data
            let dataArray = encoder.encode(data); // Convert to ArrayBuffer

            if (window.bleComms.version.includes(this.B)) {
                await window.bleComms.rxCharacteristic.writeValue(dataArray);
            } else {
                await window.bleComms.txCharacteristic.writeValue(dataArray);
            }
            
            //await new Promise(resolve => setTimeout(resolve, SERIAL_DELAY));
        }
    }

    async setData(data, add_data = "") {
        if (window.bleComms.txCharacteristic) {
            data += add_data;

            if (!/^[A-Z]/.test(data.charAt(0))) {
                data += '\n';
            } else {
                data += '~';
            }

            const encoder = new TextEncoder();
            const encodedData = encoder.encode(data);

            // Split the data into chunks and send each chunk separately.
            for (let i = 0; i < encodedData.length; i += MAX_CHUNK_SIZE) {
                const chunk = encodedData.slice(i, i + MAX_CHUNK_SIZE);
                if (window.bleComms.version.includes(this.B)) {
                    await window.bleComms.rxCharacteristic.writeValue(chunk);
                } else {
                    await window.bleComms.txCharacteristic.writeValue(chunk);
                }
            };
            // wait for SERIAL_DELAY
            await new Promise(resolve => setTimeout(resolve, SERIAL_DELAY));
            return STATUS_SUCCESS;
        } else {
            return STATUS_FAILURE;
        }
    }

    enableAppending(disableCharacter) {
        this.data = '';
        this.appendData = true;
        this.disableCharacter = disableCharacter;
    }

    disableAppending() {
        this.appendData = false;
    }

    waitForDataComplete(timeout = 1000) { // Default timeout
        return Promise.race([
          new Promise((resolve, reject) => {
            this.intervalId = setInterval(() => {
              if (!this.appendData) {
                clearInterval(this.intervalId);
                resolve();
              }
            }, DATA_CHECK_RATE); // Check every x ms
          }),
          this.timeoutId = new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), timeout))
        ]);
    }

    clearWaiting = () => {
        clearInterval(this.intervalId);
        clearTimeout(this.timeoutId);
    }

    async handleNotifications(event) {

        const value = event.target.value;
        const decoder = new TextDecoder();
        const dataString = decoder.decode(value);
        
        // If initialMessages
        if (this.initialMessagesFlag) {
            // Clear the existing timeout if there is one.
            if (this.timeoutId !== null) {
                clearTimeout(this.timeoutId);
            }
            if (dataString.includes("Ready!")) {
                
                //console.log('Ready message received');
                this.resolveInitialMessagesPromise();
            } else {
                this.timeoutId = setTimeout(this.resolveInitialMessagesPromise, BLE_CONNECT_TIMEOUT);
            }
        } else {
            if (!this.appendData) {
                return;
            }
            const data = dataString;
            this.data += data;
            if (window.bleComms.version.includes(this.B)) {
                if (this.data.endsWith(this.disableCharacter)) {
                    this.appendData = false;
                }
            } else {
                if (data.includes(this.disableCharacter)) {
                    this.appendData = false;
                }
            }

        }

        
        /*// Check if the buffer contains a full message
        const endOfMessageIndex = this.buffer.indexOf('\n');
        if (endOfMessageIndex !== -1) {
            const message = this.buffer.substring(0, endOfMessageIndex);
            //console.log('Received message: ' + message);

            // Remove the processed message from the buffer
            this.buffer = this.buffer.substring(endOfMessageIndex + 1);
        }*/
    }


    async initCalibration() {
        try {
            this.enableAppending('c');
            await this.setData('c');
            //console.log("initial calibration message sent")
            await this.waitForDataComplete();
            //console.log("robot response data", this.data)
            // process and return the data
            const data = this.data;
            
            let dataAngles = null;
            if (window.bleComms.version.includes(this.NYB)) {
                // Split data by new lines
                let dataArr = data.split('\n');
                // Clean data
                let cleanedData = dataArr[1].replace(/[\t\r]/g, '');
                // Split data by commas
                dataAngles = cleanedData.split(',');
                dataAngles = dataAngles.map(item => parseInt(item));
            } else {
                const firstCommaIndex = data.indexOf(',');
                const firstSpaceOrTabIndex = data.lastIndexOf(' ', firstCommaIndex);
                const firstTabIndex = data.lastIndexOf('\t', firstCommaIndex);
                const startIndex = Math.max(firstSpaceOrTabIndex, firstTabIndex);
                dataAngles = data.substring(startIndex).trim();
                dataAngles = dataAngles.split(',').map(item => parseInt(item));
                dataAngles = dataAngles.filter(item => !isNaN(item));
            }
            // Data structure for output
            let calibAngles = {};
            LS_SERVO_NAMES.forEach((name, index) => {
                calibAngles[name] = dataAngles[LS_SERVO_INDICES[name]];
            });
            return calibAngles;
        } catch (err) {
            console.log("calibration failed: ", err)
            return STATUS_FAILURE;
        }
    }

    async setCalibration(data_array) {

        try {
            // Create Message String of the form cjointIndex1 offset1 jointIndex2 offset2 
                // where data_array = [jointIndex1, offset1, jointIndex2, offset2, ...]
            let message = 'c';
            for (let i = 0; i < data_array.length; i+=2) {
                message += `${data_array[i]} ${data_array[i+1]} `;
            }
            // Remove the trailing space
            message = message.trim();
            // Send the message over BLE
            await this.setData(message);

            return STATUS_SUCCESS;
        } catch {
            return STATUS_FAILURE;
        }
    }

    async saveCalibration() {
        try {
            await this.setData('s');
            return STATUS_SUCCESS;
        } catch {
            return STATUS_FAILURE;
        }
    }

    async abortCalibration() {
        try {
            await this.setData('a');
            return STATUS_SUCCESS;
        } catch {
            return STATUS_FAILURE;
        }
    }

    // Bittle versions only, not nybble
    disableGyro = async() => {
        await new Promise(resolve => setTimeout(resolve, 500));
        await this.setData('gb'); // turn off gyro balance
    };

    
    getBattery = async () => {

        let T_BATTERY = 'h';
        if (window.bleComms.version === "BittleBV1") {
            T_BATTERY = 'P';
        } else if (window.bleComms.version === "BittleBV0") {
            return LS_SENSOR_REJECT_VALUE;
        }
        try {
            this.enableAppending(T_BATTERY);
            await this.setData(T_BATTERY);
            await this.waitForDataComplete();
            
            let data_value = [];
            if (window.bleComms.version === "BittleBV1") {
                data_value = this.data.split('\n');
                const joined = Array.isArray(data_value) ? data_value.join(' ') : String(data_value);
                const m = joined.match(/[-+]?\d*\.?\d+/);
                data_value = m ? parseFloat(m[0]) : NaN;
                data_value = parseFloat(data_value);

            } else {
                data_value = this.data.split('\n');
                // find which element in data_value array has a "=" in it
                data_value = data_value.find(item => item.includes("="));
                // remove leading "="
                data_value = data_value.slice(1);
                data_value = parseFloat(data_value);
            }
            return data_value;
        } catch (error) {
            console.log(error);
            return LS_SENSOR_REJECT_VALUE;
        }
    };

    
};

export const bleDeviceLS = new BluetoothDevice();

export const LS_CALIB_CMDS = { 
    CALIBRATE: 'c',  // Send robot to calibration posture, attach legs, fine-tune joint offsets
    // Format: 'c jointIndex1 offset1 jointIndex2 offset2 ...'
    SAVE: 's',  // Save the calibration values
    ABORT: 'a',  // Abort the calibration values
}

const LS_BEHAVIORS = {
    // Skills - Behaviors
    COME: 'kcmh',
    BOXING: 'kbx',
    HANDS_UP: 'khu',
    HIGH_FIVE: 'kfiv',
    KICK: 'kkc',
    NOD: 'knd',
    SHAKE: 'khsk',
    WAVE: 'kwh',
    BACKFLIP: 'kbf',
    FRONT_FLIP: 'kff',
    HANDSTAND: 'khds',
    JUMP: 'kjmp',
    MOONWALK: 'kmw',
    PUSH_UPS: 'kpu',
    PUSH_UPS_ONE_HAND: 'kpu1',
    ROLL_OVER: 'krl',
    DIG: 'kdg',
    PLAY_DEAD: 'kpd',
    SCRATCH: 'kscrh',
    SNIFF: 'ksnf',
    ALERT: 'kts',
    TABLE: 'ktbl',
    CHECK: 'kck',
    CHEERS: 'kchr',
    GOOD_DOG: 'kgdb',
    HUG: 'khg',
    HI: 'khi',
    ANGER: 'kang',
    RECOVERY_MODE: 'krc'
}


export const BEHAVIOR_DELAY_MAP = {
    [LS_BEHAVIORS.COME]: "5.6",
    [LS_BEHAVIORS.BOXING]: "7.8",
    [LS_BEHAVIORS.HANDS_UP]: "7.0",
    [LS_BEHAVIORS.HIGH_FIVE]: "5.2",
    [LS_BEHAVIORS.KICK]: "1.1",
    [LS_BEHAVIORS.NOD]: "1.0",
    [LS_BEHAVIORS.SHAKE]: "6.0",
    [LS_BEHAVIORS.WAVE]: "1.7",
    [LS_BEHAVIORS.BACKFLIP]: "2.5",
    [LS_BEHAVIORS.FRONT_FLIP]: "2.5",
    [LS_BEHAVIORS.HANDSTAND]: "4.5",
    [LS_BEHAVIORS.JUMP]: "1.5",
    [LS_BEHAVIORS.MOONWALK]: "5.2",
    [LS_BEHAVIORS.PUSH_UPS]: "5.2",
    [LS_BEHAVIORS.PUSH_UPS_ONE_HAND]: "9.7",
    [LS_BEHAVIORS.ROLL_OVER]: "4.2",
    [LS_BEHAVIORS.DIG]: "3.4",
    [LS_BEHAVIORS.PLAY_DEAD]: "11.1",
    [LS_BEHAVIORS.SCRATCH]: "3.4",
    [LS_BEHAVIORS.SNIFF]: "3.4",
    [LS_BEHAVIORS.ALERT]: "1.6",
    [LS_BEHAVIORS.TABLE]: "2.7",
    [LS_BEHAVIORS.CHECK]: "5.3",
    [LS_BEHAVIORS.CHEERS]: "3.5",
    [LS_BEHAVIORS.GOOD_DOG]: "2.1",
    [LS_BEHAVIORS.HUG]: "8.8",
    [LS_BEHAVIORS.HI]: "5.3",
    [LS_BEHAVIORS.ANGER]: "3.5",
}


export const LS_INFO = {
    'Version':'?',  // Get the model and software version
    'Joint Angles':'j',  // Print joint angles, specific or all. Example: 'j 8' prints the angle of joint 8.
    'DOF':'L',  // List of DOFx joint angles
    'Gryo Data':'v',  // Print the Gyro data once
    'Verobse Gyro Data':'V',  // Toggle verbosely print Gyro data
};

export const LS_CONTROLS = {
    'Rest':'d',  // Disable Servos or Rest command
    'Beep': 'b',  // Beep; format: 'b note1 duration1 note2 duration2 ...', note is in Hz and duration in seconds = 1/value
    'Toggle Gyro': 'G',  // Toggle on/off the gyro 
    'Pause':'p',  // Pause command
    'Servo Incremental': 'm',  // Servo Incremental command
    'Servo Simultaneous': 'i',  // Servo Simultaneous command
};

export const POSTURES_MAP = {
    'Resting':'RESTING',
    'Sitting':'SITTING',
    'Standing':'STANDING',
    'Stretching':'STRETCHING',
    'Drop Front Legs': 'DROP_FRONT_LEGS',
    'Landing': 'LANDING',
    'Calibration':'CALIBRATION',
};
export const POSTURES = Object.keys(POSTURES_MAP);


export const GAITS_MAP = {
    'Walk': {'F': 'kwkF', 'L': 'kwkL', 'R': 'kwkR', 'X': 'kwkX'},
    'Backward': {'B': 'kbk', 'L': 'kbkL', 'R': 'kbkR', 'X': 'kbkX'},
    'Spin': {'L': 'kvtL', 'R': 'kvtR',}, // 'X': 'kvtX'
    'Trot': {'F': 'ktrF', 'L': 'ktrL', 'R': 'ktrR', 'X': 'ktrX'},
    'Crawl': {'F': 'kcrF', 'L': 'kcrL', 'R': 'kcrR', 'X': 'kcrX'},
    'Push': {'F': 'kphF', 'L': 'kphL', 'R': 'kphR', 'X': 'kphX'},
    'Jump': {'F': 'kjpF'},
};
export const GAITS = Object.keys(GAITS_MAP);
//export const GAITS = ['Bound', 'Backward', 'Crawl', 'Jump', 'Push', 'Trot', 'Step', 'Walk'];

export const GAITS_DIRS = ['Forward', 'Backward', 'Left', 'Right', 'Random'];
export const GAITS_DIRS_MAP = {
    'Forward': 'F',
    'Backward': 'B',
    'Left': 'L',
    'Right': 'R',
}

export const GAITS_DIRS_OPTS = {
    'Walk': ['Forward', 'Left', 'Right', 'Random'],
    'Backward': ['Backward', 'Left', 'Right', 'Random'],
    'Spin': ['Left', 'Right'],
    'Trot': ['Forward', 'Left', 'Right', 'Random'],
    'Crawl': ['Forward', 'Left', 'Right', 'Random'],
    'Push': ['Forward', 'Left', 'Right', 'Random'],
    'Jump': ['Forward'],
}

export const BEHAVIORS = ['Come Here', 'Boxing', 'Hands Up', 'High Five', 'Kick', 'Nod', 'Shake', 'Wave', 'Backflip', 'Front Flip', 'Handstand', 'Jump', 'Moonwalk', 'Push Ups', 'Push Ups One Hand', 'Roll Over', 'Dig', 'Play Dead', 'Scratch', 'Sniff', 'Alert', 'Table', 'Check', 'Cheers', 'Good Dog', 'Hug', 'Hi', 'Anger', 'Recovery Mode'];
export const BEHAVIORS_MAP = {
    'Come Here': 'kcmh',  
    'Boxing': 'kbx',
    'Hands Up': 'khu',
    'High Five': 'kfiv',
    'Kick': 'kkc',
    'Nod': 'knd',
    'Shake': 'khsk',
    'Wave': 'kwh',
    'Backflip': 'kbf',
    'Front Flip': 'kff',
    'Handstand': 'khds',
    'Jump': 'kjmp',
    'Moonwalk': 'kmw',
    'Push Ups': 'kpu',
    'Push Ups One Hand': 'kpu1',
    'Roll Over': 'krl',
    'Dig': 'kdg',
    'Play Dead': 'kpd',
    'Scratch': 'kscrh',
    'Sniff': 'ksnf',
    'Alert': 'kts',
    'Table': 'ktbl',
    'Check': 'kck',
    'Cheers': 'kchr',
    'Good Dog': 'kgdb',
    'Hug': 'khg',
    'Hi': 'khi',
    'Anger': 'kang',
    'Recovery Mode': 'krc',
};
export const BEHAVIORS_NAMES_MAP = {
    'Come Here': "COME_HERE",
    'Boxing': "BOXING",
    'Hands Up': "HANDS_UP",
    'High Five': "HIGH_FIVE",
    'Kick': "KICK",
    'Nod': "NOD",
    'Shake': "SHAKE",
    'Wave': "WAVE",
    'Backflip': "BACKFLIP",
    'Front Flip': "FRONT_FLIP",
    'Handstand': "HANDSTAND",
    'Jump': "JUMP",
    'Moonwalk': "MOONWALK",
    'Push Ups': "PUSH_UPS",
    'Push Ups One Hand': "PUSH_UPS_ONE_HAND",
    'Roll Over': "ROLL_OVER",
    'Dig': "DIG",
    'Play Dead': "PLAY_DEAD",
    'Scratch': "SCRATCH",
    'Sniff': "SNIFF",
    'Alert': "ALERT",
    'Table': "TABLE",
    'Check': "CHECK",
    'Cheers': "CHEERS",
    'Good Dog': "GOOD_DOG",
    'Hug': "HUG",
    'Hi': "HI",
    'Anger': "ANGER",
    'Recovery Mode': "RECOVERY_MODE",
}



const BEHAVIORS_BASIC = [
    'Come Here', 'Boxing',
    'Hands Up',  'High Five',
    'Kick',      'Nod',
    'Shake',     'Wave'
]
const BEHAVIOR_PERFORMANCE = [
    'Backflip',         'Front Flip',
    'Handstand',        'Jump',
    'Moonwalk',         'Push Ups',
    'Push Ups One Hand', 'Roll Over'
]
const BEHAVIOR_PLAYFUL = [
    'Dig',      'Play Dead',
    'Scratch',  'Sniff',
    'Alert',    'Table',
    'Check',    'Cheers',
    'Good Dog', 'Hug',
    'Hi',       'Anger'
]

export const BEHAVIOR_CATEGORIES = ['Basic Tricks', 'Performance Tricks', 'Playful Gestures'];
export const BEHAVIOR_CATEGORIES_MAP = {
    'Basic Tricks': BEHAVIORS_BASIC,
    'Performance Tricks': BEHAVIOR_PERFORMANCE,
    'Playful Gestures': BEHAVIOR_PLAYFUL,
};


export const LS_SKILLS = {
    'posture': {
        'Resting':'krest',
        'Sitting':'ksit',
        'Standing':'kup',
        'Stretching':'kstr',
        'Drop Front Legs': 'kdropped',
        'Landing': 'klnd',
        'Calibration':'kzero',
    },
    'gait': {
        'Walk': {'F': 'kwkF', 'L': 'kwkL', 'R': 'kwkR', 'X': 'kwkX'},
        'Trot': {'F': 'ktrF', 'L': 'ktrL', 'R': 'ktrR', 'X': 'ktrX'},
        'Crawl': {'F': 'kcrF', 'L': 'kcrL', 'R': 'kcrR', 'X': 'kcrX'},
        'Push': {'F': 'kphF', 'L': 'kphL', 'R': 'kphR', 'X': 'kphX'},
        'Backward': {'B': 'kbk', 'L': 'kbkL', 'R': 'kbkR', 'X': 'kbkX'},
        'Spin': {'L': 'kvtL', 'R': 'kvtR'},
        'Jump': {'F': 'kjpF'},
    },
    'behavior': {
        // Basic Tricks
        'Come Here': 'kcmh',  
        'Boxing': 'kbx',
        'Hands Up': 'khu',
        'High Five': 'kfiv',
        'Kick': 'kkc',
        'Nod': 'knd',
        'Shake': 'khsk',
        'Wave': 'kwh',
        // Performance Tricks
        'Backflip': 'kbf',
        'Front Flip': 'kff',
        'Handstand': 'khds',
        'Jump': 'kjmp',
        'Moonwalk': 'kmw',
        'Push Ups': 'kpu',
        'Push Ups One Hand': 'kpu1',
        'Roll Over': 'krl',
        // Playful Gestures
        'Dig': 'kdg',
        'Play Dead': 'kpd',
        'Scratch': 'kscrh',
        'Sniff': 'ksnf',
        'Alert': 'kts',
        'Table': 'ktbl',
        // Interactive Responses
        'Check': 'kck',
        'Cheers': 'kchr',
        'Good Dog': 'kgdb',
        'Hug': 'khg',
        'Hi': 'khi',
        'Anger': 'kang',
        // Special Functions
        'Recovery Mode': 'krc',
    }
};

export const LS_SKILLS_DIRS = {
    'Forward': 'F',
    'Backward': 'B',
    'Left': 'L',
    'Right': 'R',
    'Random': 'X'
};


export const SERVO_RANGES = {
    'Neck [0]': [-70, 70],
    'Front Left Shoulder [8]': [-135, 70],
    'Front Left Elbow [12]': [-70, 135],
    'Back Left Hip [11]': [-70, 135],
    'Back Left Knee [15]': [-70, 135],
    'Front Right Shoulder [9]': [-135, 70],
    'Front Right Elbow [13]': [-70, 135],
    'Back Right Hip [10]': [-70, 135],
    'Back Right Knee [14]': [-70, 135],
}

export const LS_SERVO_INDICES = {
    'Neck': 0,
    'Front Left Elbow': 12,
    'Front Left Shoulder': 8,
    'Back Left Hip': 11,
    'Back Left Knee': 15,
    'Front Right Elbow': 13,
    'Front Right Shoulder': 9,
    'Back Right Hip': 10,
    'Back Right Knee': 14,
};

const LS_SERVO_INDICES_BLOCK_ORDER = {
    'Neck': 0,
    'Front Left Shoulder': 8,
    'Front Left Elbow': 12,
    'Front Right Shoulder': 9,
    'Front Right Elbow': 13,
    'Back Left Hip': 11,
    'Back Left Knee': 15,
    'Back Right Hip': 10,
    'Back Right Knee': 14,
}
export const LS_SERVO_NAMES = Object.keys(LS_SERVO_INDICES);
export const LS_SERVO_NAMES_FULL = Object.keys(LS_SERVO_INDICES).map(key => `${key} (${LS_SERVO_INDICES[key]})`);
export const LS_SERVO_NAMES_L = Object.keys(LS_SERVO_INDICES).filter(name => name.includes('Left'));
export const LS_SERVO_NAMES_R = Object.keys(LS_SERVO_INDICES).filter(name => name.includes('Right'));

export const LS_SERVO_NAMES_W_IND = Object.keys(LS_SERVO_INDICES_BLOCK_ORDER).map(key => `${key} [${LS_SERVO_INDICES[key]}]`);